import { STAY_RATINGS } from 'config/constants';
import { getJson, setJson } from 'lib/localStore';
import { negativeStayRatingSelected, positiveStayRatingSelected } from 'lib/gaTracking/crossPageEvents';

interface CreateStayRatingArgs {
  bookingId: string;
  propertyId: string;
  rating: string;
  bookingRef: string;
}

export const createStayRating = ({ bookingId, propertyId, rating, bookingRef }: CreateStayRatingArgs) => {
  if (rating === STAY_RATINGS.POSITIVE) {
    positiveStayRatingSelected(propertyId, bookingRef);
  } else {
    negativeStayRatingSelected(propertyId, bookingRef);
  }
  setJson(`rating_${bookingId}`, { propertyId, rating });
};

export const getStayRatingForBookingId = (bookingId: string) => {
  return getJson(`rating_${bookingId}`);
};
